import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from 'src/shadcn/components/ui/alert-dialog';
import * as React from 'react';
import { RouterLinks } from 'src/routing/routerLinks';
import { useAsmRouter } from 'src/utils/hooks';

export interface IInvalidSubscriptionModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

export const InvalidSubscriptionModal: React.FunctionComponent<
  IInvalidSubscriptionModalProps
> = props => {
  const router = useAsmRouter();
  return (
    <AlertDialog open={props.isOpen} onOpenChange={props.setIsOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            Whoops seems like you're not subscribed 🥶
          </AlertDialogTitle>
          <AlertDialogDescription>
            A subscription is required to access the awesome Sparkify features.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Ok</AlertDialogCancel>
          <AlertDialogAction
            onClick={() => {
              router.pushFlat(RouterLinks.Billing);
            }}
          >
            Go to billing
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
